import { memo } from "react";

import { IconDoubleCheckmark } from "@synthesis/shared-icons";
import { Button } from "@synthesis/shared-ui";

import { useApplicationNotifications } from "../use-application-notifications";

export const MarkAllReadButton = memo(() => {
  const { markAllNotificationsAsRead } = useApplicationNotifications();

  return (
    <Button
      type="button"
      size="sm"
      theme="secondary"
      className="shrink-0"
      leftIcon={<IconDoubleCheckmark className="size-5" />}
      onClick={markAllNotificationsAsRead}
    >
      Прочесть всё
    </Button>
  );
});

MarkAllReadButton.displayName = "MarkAllReadButton";
